import React, { useEffect, useState } from 'react'
import { TableCustom } from '../../components/Table'
import { TABLE_SETTING_COMPANY_NEWS } from '../../helper'
import { toast } from 'react-toastify'
import useAxiosInstance from '../../hooks/useAxios'
import { useNavigate } from 'react-router-dom'
import { Paginator } from '../../components/Paginator'

const CompanyNews = () => {
    const [response, setResponse] = useState([])
    const [loading, setLoading] = useState(false);
    const axiosInstance = useAxiosInstance();
    
    const [page,setPage] = useState(1)
    const [pageSize,setPageSize] = useState(50);
    const [intermediatePageNumber,setIntermediatePageNumber] = useState(0)

    const [restart,setRestart] = useState(0);
    const [source,setSource] = useState("wokelo");
    const history = useNavigate()
    useEffect(() => {
        setLoading(true);
        axiosInstance
            .post(`/news/get_all_company_news/`,
                {   
                    "page":page,
                    "page_size":pageSize,
                    "source":source
                }
            )
            .then((res) => {
                setResponse(res.data);
                setIntermediatePageNumber(res.data.current_page)
                setLoading(false)
            })
            .catch((err) => {
                console.log(err);
                toast.error("Something went while getting orgs");
                setLoading(false);
            });
    }, [source,restart]);

    return (
        <div>
            <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
                <p className="text-2xl flex items-center justify-between text-black font-medium mb-4">
                    <p>Company News</p>
                    <button
                        disabled={loading}
                        onClick={() => {
                            history('/company-news/add')
                        }}
                        className="text-sm bg-black disabled:cursor-not-allowed text-white font-medium px-2 py-1 rounded-md mt-2"
                    >Add Company News</button>
                </p>
                <div className="rounded-xl bg-gray-100 p-3">
                    <p className="text-sm font-semibold mb-2">Select Source</p>
                    <select 
                    onChange={(e)=>{
                        setSource(e.target.value)
                    }}
                    value={source}
                    disabled
                    className='border rounded-lg px-3 py-2 w-full focus:ring-0 focus:outline-gray-400 disabled:bg-gray-300'
                    >   
                        <option value="">Choose</option>
                        <option value="wokelo">Wokelo</option>
                        <option value="google">Google</option>
                        <option value="Crunchbase">Crunchbase</option>
                        <option value="bing">bing</option>
                    </select>
                    <TableCustom
                        columns={TABLE_SETTING_COMPANY_NEWS}
                        data={{ 'data': response.data }}
                        loading={loading}
                        handleEdit={id=>history(`/company-news/edit/?pk=${id}`)}
                        handleDelete={id=>{
                           const confirm = window.confirm(`Are you sure, you want tp remove this ${id}?`)
                           if (!confirm){
                            return 
                           }
                           setLoading(true);
                            axiosInstance
                            .post("/news/delete_a_company_news/", {
                                pk:id
                            })
                            .then((res) => {
                                setLoading(false);
                                toast.success('News deleted Successfully')
                                setRestart(prev=>prev+1)
                            })
                            .catch((err) => {
                                setLoading(false);
                                console.log(err?.response?.data?.message);
                            }); 
                        }}
                        handleSelect={null}
                        className="max-w-full"
                    />
                    <Paginator
                        data={response}
                        intermidiatePageNumber={intermediatePageNumber}
                        loading={loading}
                        pageSize={pageSize}
                        setIntermidiatePageNumber={setIntermediatePageNumber}
                        setPage={setPage}
                        setPageSize={setPageSize}
                    />
                </div>
            </div>
        </div>
    )
}

export default CompanyNews